"use client";

import { c as _c } from "react/compiler-runtime";
import { useContentfulInspectorMode, useContentfulLiveUpdates } from "@contentful/live-preview/react";
interface PersonalizedVariant<TFields> {
  id: string;
  fields: TFields;
}
interface LivePersonalizedEntry<TFields> {
  fields: TFields;
  inspectorProps: (fieldId: string) => Record<string, string> | undefined;
}

/**
 * Makes the arm `<Experience>` (via `PersonalizedEntry`) selects for a personalized
 * Contentful entry live-editable in draft mode. Reuse for any personalized type: the
 * component receives the selected `{ id, fields }`, calls this hook, and renders its
 * view with the returned live `fields` and `inspectorProps(fieldId)` for click-to-edit.
 * In non-draft mode both Contentful hooks are no-ops, so it passes through unchanged.
 */
export function useLivePersonalizedEntry(t0) {
  const $ = _c(12);
  const {
    id,
    fields
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = {
      id
    };
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      tags: []
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== fields || $[4] !== t1) {
    t3 = {
      sys: t1,
      fields,
      metadata: t2
    };
    $[3] = fields;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const live = useContentfulLiveUpdates(t3);
  const inspector = useContentfulInspectorMode();
  let t4;
  if ($[6] !== id || $[7] !== inspector) {
    t4 = fieldId => inspector({
      entryId: id,
      fieldId
    }) ?? undefined;
    $[6] = id;
    $[7] = inspector;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== live.fields || $[10] !== t4) {
    t5 = {
      fields: live.fields,
      inspectorProps: t4
    };
    $[9] = live.fields;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}